import EmptyCard from "@/components/UI/EmptyPages/EmptyCard";

const TermsConditions = () => (
  <EmptyCard
    title="Terms & Conditions is coming soon"
    subtitle="This module is not built yet. Check back later."
  />
);

export default TermsConditions;
